import MainLotView from './main-lot-view';
export default MainLotView;